const colors = {
    blue: '#2957FF',
    darkBlue: '#005AA5',
    brandingBlue: '#3863FF',
    bradingYellow: '#FCF800',
    blueSupport: '#465EFF',
    borderBlue: '#3D5AFF',
    lightBlue: '#001DE0',
    yellow: '#FFF000',
    borderSoft: '#DBDDE1',
    black: '#000000',
    white: '#fff',
    whiteDark: '#F5F5F5',
    lightGrey: '#F0F5FF',
    grey: '#E5E5E5',
    disabledButton: '#EDEDED',
    disabledText: '#BABABA',
    greyBlue: '#EBF2FF',
    darkGrey: '#212227',
    green: '#39AC3E',
    lightGreen: '#D9F2DA',
    red: '#E50606',
    lightRed: '#FECDCD',
    backgroundTable: '#F1F2F4',
    valueGrey: '#828282',
    neutral: '#F4F5F7',
    iconSoft: '#9BA0AA',
};

export default colors;